import React, { useState } from "react";
import { Menu } from "lucide-react";
import Sidebar from "../component/Sidebar";
import AdminNavbar from "../component/AdminNavbar";

function AdminLayout({ children }) {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (

    <>
      <style>{`

        /* ================================
           ADMIN MAIN LAYOUT
        ================================= */

        .admin-layout {
          display: flex;
          width: 100%;
          min-height: 100vh;
          background: #f8fafc;
          overflow-x: hidden;
        }


        /* ================================
           ADMIN NAVBAR
        ================================= */

        .admin-navbar-wrapper {
          position: fixed;
          top: 0;
          left: 250px;
          right: 0;
          height: 70px;
          z-index: 1100;

          display: flex;
          align-items: center;
        }

        /* Hamburger button — only rendered/visible on mobile */
        .admin-mobile-menu-btn {
          display: none;
          background: none;
          border: none;
          padding: 8px;
          margin-left: 8px;
          color: #3E0F8D;
          cursor: pointer;
          align-items: center;
          justify-content: center;
        }


        /* ================================
           SIDEBAR AREA
        ================================= */

        .admin-sidebar-wrapper {
          width: 250px;
          min-width: 250px;
          height: 100vh;

          position: fixed;
          top: 0;
          left: 0;

          z-index: 1000;
        }


        /* ================================
           MAIN CONTENT
        ================================= */

        .admin-content {
          width: calc(100% - 250px);
          min-height: 100vh;

          margin-left: 250px;

          padding: 95px 25px 25px 25px;

          box-sizing: border-box;

          background: #f8fafc;

          overflow-x: hidden;
        }


        /* ================================
           CONTENT INNER AREA
        ================================= */

        .admin-content-inner {
          width: 100%;
          max-width: 1600px;
          margin: 0 auto;
        }


        /* ================================
           TABLET
        ================================= */

        @media (max-width: 992px) {

          .admin-sidebar-wrapper {
            width: 220px;
            min-width: 220px;
          }

          .admin-navbar-wrapper {
            left: 220px;
          }

          .admin-content {
            width: calc(100% - 220px);
            margin-left: 220px;
            padding: 95px 20px 20px 20px;
          }

        }


        /* ================================
           MOBILE
           Sidebar becomes a fixed slide-in
           drawer (handled inside Sidebar.jsx
           via the mobile-open class). The
           content column and navbar no longer
           reserve space for it.
        ================================= */

        @media (max-width: 768px) {

          .admin-layout {
            display: block;
          }


          /* Navbar */

          .admin-navbar-wrapper {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            height: 70px;
          }

          .admin-mobile-menu-btn {
            display: flex;
          }


          /* Sidebar wrapper no longer takes layout space:
             Sidebar.jsx itself is fixed-positioned and
             slides in/out via transform. */

          .admin-sidebar-wrapper {
            width: 0;
            min-width: 0;
            height: 0;
            position: static;
          }


          /* Content */

          .admin-content {
            width: 100%;
            margin-left: 0;

            padding: 85px 15px 15px 15px;
          }

        }

      `}</style>


      <div className="admin-layout">


        {/* ==========================================
            SIDEBAR
        ========================================== */}

        <div className="admin-sidebar-wrapper">

          <Sidebar
            isMobileOpen={mobileOpen}
            onClose={() => setMobileOpen(false)}
          />

        </div>


        {/* ==========================================
            ADMIN NAVBAR
        ========================================== */}

        <div className="admin-navbar-wrapper">

          <button
            type="button"
            className="admin-mobile-menu-btn"
            onClick={() => setMobileOpen(true)}
            aria-label="Open menu"
          >
            <Menu size={22} />
          </button>

          <AdminNavbar />

        </div>


        {/* ==========================================
            MAIN CONTENT
        ========================================== */}

        <main className="admin-content">

          <div className="admin-content-inner">

            {children}

          </div>

        </main>


      </div>

    </>
  );
}

export default AdminLayout;